/**
 *
 * PriorityLowTag
 *
 */

import React, { memo } from 'react';
import styled from 'styled-components';

import { COLORS } from 'theme';
import { ChevronDownIcon } from 'assets/v2/icons';
import Tag from '..';

const StyledTag = styled(Tag)`
  &.MuiChip-root {
    color: ${COLORS.yellowDark};
    background: ${COLORS.yellowLight};
    border-color: ${COLORS.yellow};
    border-radius: ${({ theme }) => theme.borderRadius.secondary};

    &&& .MuiChip-icon path {
      fill: ${COLORS.yellow};
    }
  }
`;

function PriorityLowTag(props) {
  return <StyledTag label="Low" icon={<ChevronDownIcon />} {...props} />;
}

export default memo(PriorityLowTag);
